import QuickActionsPanel from './quick-actions-panel';
import CourseworkCard from './coursework-card';
export default {
  data: {
    selected_filter_by: null,
    selected_sort_by: null,
    coursework_listing: null,
    initial_count: 0,
    course: null,
    user_preferences: null,
    hide_completed: false,
    search_enabled: false,
    search_query: null,
    allow_search_on_blur: true
  },
  components: {
    'quick-actions-panel': QuickActionsPanel,
    'coursework-card': CourseworkCard,
  },
  computed: {
    showDueDates() {
      return (!this.course.adaptive || this.user_preferences && !this.user_preferences.hide_due_dates);
    },
    hasDueDates() {
      return _.any(this.coursework_listing, function (coursework) { return !coursework.hide_due_date; });
    },
    filterBy() {
      let coursework = _.map(this.coursework_listing, function(cw) {
        return {name: cw.family_name, value: `coursework.${cw.family_name}`};
      });

      let session = _.map(this.course.lectures, function(lecture) {
        return {name: lecture.title_with_number, value: `session.${lecture.title}`, disabled: lecture.coursework_count === 0};
      });

      let isUniq = function (item) { return item.name; };

      return [{name: 'Coursework', options: _.uniq(coursework, isUniq)}, {name: 'Session', options: _.uniq(session, isUniq)}];
    },
    sortBy() {
      let options = ['Name', 'Number'];

      if (this.showDueDates && this.hasDueDates) {
        options.push('Due Date');
      }
      if (this.course.adaptive && this.course.bounded_coursework_ids.length > 0) {
        options.push('Session');
      }
      return options;
    },
    filteredCoursework() {
      const self = this;
      let results = _.filter(this.coursework_listing, function(coursework) {
        let predicate1 = true;
        if (!_.isEmpty(self.selected_filter_by)) {
          let [filter_type, filter_value] = self.selected_filter_by.split('.');
          predicate1 = (filter_type === 'coursework') ? coursework.family_name === filter_value :
            coursework.sessions[0] && _.any(coursework.sessions, function(session) { return session.name === filter_value; });
        }
        let predicate2 = self.hide_completed ? !coursework.is_completed : true;
        return predicate1 && predicate2;
      });

      if (!_.isEmpty(this.selected_sort_by)) {
        results = _.sortBy(results, function (coursework) {
          if (self.selected_sort_by === 'Name') {
            return coursework.name;
          } else if (self.selected_sort_by === 'Due Date') {
            return (new Date(coursework.due_date));
          } else if (self.selected_sort_by === 'Session') {
            return coursework.sessions[0] && coursework.sessions[0].coursework_order;
          } else {
            return coursework.number;
          }
        });
      }

      return results;
    },
    searchApplied() {
      return this.search_enabled && !_.isEmpty(this.search_query);
    }
  },
  methods: {
    bindData(coursework_listing, course, user_preferences) {
      this.coursework_listing = coursework_listing;
      this.initial_count = this.coursework_listing.length;

      this.course = course;
      this.user_preferences = user_preferences;
    },
    toggleSearch() {
      if (this.searchApplied) {
        this.search_query = null;
        if (this.initial_count > this.coursework_listing.length) {
          this.getCourseworkListing();
        }
      }
      this.search_enabled = !this.search_enabled;
    },
    searchOnEnter() {
      if (!_.isEmpty(this.search_query)) {
        this.getCourseworkListing();
      }
    },
    searchOnBlur() {
      if (_.isEmpty(this.search_query)) {
        this.search_enabled = false;
      } else {
        if (this.allow_search_on_blur) {
          this.getCourseworkListing();
        }
      }
    },
    getCourseworkListing() {
      let self = this;

      let request = new Kadenze.AjaxRequest({
        type: 'GET',
        url: Kadenze.Routes.course_coursework_index_path(this.course.id, {q: self.search_query}),
        loadingIndicator: {container: self.$el}
      });

      request.done(function(data, textStatus, xhr) {
        self.coursework_listing = data;
      });

      return request;
    },
  },
  mounted() {
    const self = this;
  },
  destroyed() {
    this.hide_completed = false;
  }
};
